(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    (() => {
    // Keeps --dorie-facets-top equal to the lowest visible edge of the header /
    // announcement bar, so the sticky "Filter & Sort" bar never slides under
    // them (also follows a header that hides or resizes on scroll).
    const SELECTORS = '#header-component, #dorie-sale-bar, .announcement-bar';
    let frame = 0;

    const measure = () => {
      frame = 0;
      let bottom = 0;
      document.querySelectorAll(SELECTORS).forEach((el) => {
        const rect = el.getBoundingClientRect();
        if (rect.height > 0 && rect.bottom > bottom) bottom = rect.bottom;
      });
      document.documentElement.style.setProperty('--dorie-facets-top', `${Math.round(bottom)}px`);
    };

    const queue = () => {
      if (!frame) frame = requestAnimationFrame(measure);
    };

    const start = () => {
      if (!document.querySelector('.facets-toggle')) return;
      measure();
      window.addEventListener('scroll', queue, { passive: true });
      window.addEventListener('resize', queue);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', start, { once: true });
    } else {
      start();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
